import axios from 'axios'

export async function getProductDetails (productId) {
  const url = `/?fc=module&module=dbs_productsreviews&controller=api&action=getProductDetails&productId=${productId}`
  const response = await axios.get(url)
  const product = response.data.product

  if (product) {
    return product
  } else {
    throw new Error('Can not get product details')
  }
}



// WEBPACK FOOTER //
// ./src/api/productReviews/getProductDetails.js